//
// Webasyst Profile Page
//

( function($, waTheme) {

    $.ajaxSetup({
        cache: false
    });

    var AuthAdapters = ( function($) {

        AuthAdapters = function(options) {
            var that = this;

            // DOM
            that.$window = $(window);

            // VARS

            // DYNAMIC VARS

            // INIT
            that.init();
        };

        AuthAdapters.prototype.init = function() {
            var that = this;
            //
            $(".s-adapters-section").on("click", "a", function(event) {
                event.preventDefault();
                onProviderClick( $(this) );
            });

            function onProviderClick( $link ) {
                var $li = $link.closest("li"),
                    provider = $li.data("provider");

                if (provider !== 'guest' && provider !== 'signup') {
                    var width = $link.data('width') || 600,
                        height = $link.data('height') || 500,
                        left = (screen.width-width)/ 2,
                        top = (screen.height-height)/ 2,
                        href = $link.attr("href");

                    if ( ( typeof require_authorization !== "undefined" ) && !require_authorization) {
                        href = href + "&guest=1";
                    }

                    window.open(href, "oauth", "width=" + width + ",height=" + height + ",left=" + left + ",top=" + top +
                        ",status=no,toolbar=no,menubar=no");
                }
            }
        };

        return AuthAdapters;

    })($);

    waTheme.init.site.AuthAdapters = AuthAdapters;

    new window.waTheme.init.site.AuthAdapters({});

})(jQuery, window.waTheme);
